import { jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import classNames from 'classnames';
import { FixedBannerContext } from '../FixedBanner.Context/FixedBanner.Context.es.js';

const FixedBannerTitle = ({ children, ...props })=>{
    const { multiline } = useContext(FixedBannerContext);
    return jsx("p", {
        className: classNames('title', {
            multiline: multiline
        }),
        ...props,
        children: children
    });
};
FixedBannerTitle.displayName = 'FixedBanner.Title';

export { FixedBannerTitle };
//# sourceMappingURL=FixedBanner.Title.es.js.map
